import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


@Injectable({
    providedIn: 'root'
})

export class SharedService {
    loaderState = new Subject();
    loaderState$ = this.loaderState.asObservable();
    
    loaderState1 = new Subject();
    loaderState1$ = this.loaderState1.asObservable();

    constructor() { }

    /**
     * To update loader across the app
     * @param state Show/Hide
     */
    updateLoader(state:any) {
        this.loaderState.next(state);
    }
    updateLoader1(state: any) {
        this.loaderState1.next(state);
    }

    // accept only numbers and float only 
isNumberKey(evt: any) {
    const charCode = evt.which ? evt.which : evt.keyCode;
    const value = evt.target.value;

    const isDot = charCode === 46;
    const isMinus = charCode === 45;
    const isNumber = charCode >= 48 && charCode <= 57;

    // Prevent multiple dots
    if (isDot && value.includes('.')) {
        return false;
    }
    // Allow one dot
    if (isDot) {
        return true;
    }
    // Allow minus only at the beginning
    if (isMinus) {
        return value.length === 0 || (evt.target.selectionStart === 0 && !value.includes('-'));
    }
    // Allow number keys
    if (isNumber) {
        return true;
    }
    // Block all other characters
    return false;
}

  isNumberOnly(evt: any) {
    const charCode = evt.which ? evt.which : evt.keyCode;
    const value = evt.target.value;

    const isDot = charCode === 46;
    const isMinus = charCode === 45;
    const isNumber = charCode >= 48 && charCode <= 57;
    // Allow number keys
    if (isNumber) {
        return true;
    }
    // Block all other characters
    return false;
}

isVehicleOnly(evt: any) { 
  const charCode = evt.which ? evt.which : evt.keyCode;

  // Allow control keys
  if (
    charCode === 8 ||   // backspace
    charCode === 9 ||   // tab
    charCode === 37 ||  // left
    charCode === 39 ||  // right
    charCode === 46     // delete
  ) {
    return true;
  }

  // A-Z
  if (charCode >= 65 && charCode <= 90) return true;

  // a-z
  if (charCode >= 97 && charCode <= 122) return true;

  // 0-9
  if (charCode >= 48 && charCode <= 57) return true;

  return false;
}


    
getPredefinedDateRange(option: string): { startDate: any, endDate: any } | null {
    const today = new Date();
    let startDate: Date;
    let endDate: Date;
  
    switch (option) {
      case 'today':
        startDate = new Date(today);
        startDate.setHours(0, 0, 0, 0); 
        endDate = new Date(today);
        endDate.setHours(23, 59, 59, 999); 
        break;
  
      case 'yesterday':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 1);
        startDate.setHours(0, 0, 0, 0); 
        endDate = new Date(today);
        endDate.setDate(today.getDate() - 1);
        endDate.setHours(23, 59, 59, 999); 
        break;
  
      case 'last-week':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 7);
        startDate.setHours(0, 0, 0, 0); 
        endDate = new Date(today);
        endDate.setDate(today.getDate() - 1);
        endDate.setHours(23, 59, 59, 999); 
        break;
  
      case 'last-month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        startDate.setHours(0, 0, 0, 0);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999); 
        break;

    case 'current-month':
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        startDate.setHours(0, 0, 0, 0); // Start of this month
        endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        endDate.setHours(23, 59, 59, 999); // End of this month
        break;
  
      default:
        return null;
    }
  
    return { startDate, endDate };
  }
  
  convertToDateFormat(dateString: string): any {
    // Parse the date string using a custom format
    const [day, month, year, time, timezone] = dateString.split(/[-\s:]+/);
  
    // Construct a new date object from the parsed components
    const parsedDate = new Date(
      `${year}-${month}-${day}T${time}:${timezone}`
    );
  
    // If the date is invalid, handle the error
    if (isNaN(parsedDate.getTime())) {
      return 'Invalid Date';
    }
    else{
      return parsedDate
    }
  }
  
  convertToISOFormat(dateString: string): string {
    // Split the input date string into components
    const [day, month, year, hours, minutes, seconds, timezone] = dateString.match(/\d+/g)!;
  
    // Create a new Date object using the extracted values
    const date = new Date(
      Number(year),
      Number(month) - 1,  // Month is 0-indexed in JavaScript Date object
      Number(day),
      Number(hours),
      Number(minutes),
      Number(seconds)
    );
  
    // Get timezone offset in minutes and adjust the time accordingly
    const timezoneOffset = Number(timezone.slice(0, 3)) * 60 + Number(timezone.slice(3, 5));
    date.setMinutes(date.getMinutes() - timezoneOffset);
  
    // Convert the date to the required ISO format with hours and minutes
    const isoString = date.toISOString().slice(0, 16);
  
    return isoString;
  }

  // convert date format to 'dd-mm-yyyy  +530'
  formatDateToDateAndTimezone(date: Date): string {
    const pad = (n: number) => (n < 10 ? '0' + n : n);
  
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const year = date.getFullYear();
  
    const timezoneOffset = -date.getTimezoneOffset();
    const sign = timezoneOffset >= 0 ? '+' : '-';
    const timezoneHours = pad(Math.floor(Math.abs(timezoneOffset) / 60));
    const timezoneMinutes = pad(Math.abs(timezoneOffset) % 60);
  
    return `${day}-${month}-${year} ${sign}${timezoneHours}${timezoneMinutes}`;
  }

  // convert date format to 'dd-mm-yyyy hh:mm:ss +530'
  formatDate(date: Date): string {
    const pad = (n: number) => (n < 10 ? '0' + n : n);
  
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const year = date.getFullYear();
  
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
  
    const timezoneOffset = -date.getTimezoneOffset();
    const sign = timezoneOffset >= 0 ? '+' : '-';
    const timezoneHours = pad(Math.floor(Math.abs(timezoneOffset) / 60));
    const timezoneMinutes = pad(Math.abs(timezoneOffset) % 60);
  
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${sign}${timezoneHours}${timezoneMinutes}`;
  }
  formatMonthDate(date: Date): string {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    const month = monthNames[date.getMonth()]; // Get month name
    const year = date.getFullYear(); // Get full year
  console.log(month,year)
    return `${month} ${year}`;
  }

  getStartAndEndDates(date: Date): { startDate: string; endDate: string } {
    // Start of the month
    const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
  
    // End of the month
    const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  
    // Set time to the start of the day for startDate
    startDate.setHours(0, 0, 0, 0);
  
    // Set time to the end of the day for endDate
    endDate.setHours(23, 59, 59, 999);
  
    return {
      startDate: this.formatDate(startDate),
      endDate: this.formatDate(endDate),
    };
  }
  // parse Date String To Date
  parseDateStringToDate(dateString: string): Date {
    // Split the date string into components
    const [datePart, timePart, timezonePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    
    // Parse timezone
    const sign = timezonePart[0] === '+' ? 1 : -1;
    const timezoneHours = parseInt(timezonePart.slice(1, 3), 10);
    const timezoneMinutes = parseInt(timezonePart.slice(3, 5), 10);
    const timezoneOffset = sign * (timezoneHours * 60 + timezoneMinutes);
  
    // Create the date object in UTC and adjust for the timezone
    const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
    utcDate.setMinutes(utcDate.getMinutes() - timezoneOffset);
  
    return utcDate;
  }

  minimumAgeValidator(minAge: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const today = new Date();
    const dob = new Date(control.value);
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--; // adjust if birthday hasn’t occurred yet this year
    }

    return age < minAge ? { minAge: { requiredAge: minAge, actualAge: age } } : null;
  };
}
  
}
